module.exports = __webpack_public_path__ + "static/media/avatar-placeholder.e97a3021.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/avatar-placeholder.svg
// module id = n9pj
// module chunks = main